import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Catégories")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("sup", null, "ère", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "nde", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("sup", null, "ème", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    type: "flex",
    class: "categories",
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_a_select, {
                value: _ctx.categoriesSelected.firstCategorieId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoriesSelected.firstCategorieId) = $event)),
                style: {"width":"350px"},
                "dropdown-match-select-width": false,
                onSelect: _ctx.onFirstCategorieSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: null }, {
                    default: _withCtx(() => [
                      _createTextVNode("1"),
                      _hoisted_2,
                      _createTextVNode(" catégorie")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstCategories, (categorie) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: categorie.categorieId,
                      value: categorie.categorieId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onSelect"]),
              _createVNode(_component_a_select, {
                value: _ctx.categoriesSelected.secondCategorieId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.categoriesSelected.secondCategorieId) = $event)),
                style: {"width":"350px"},
                "dropdown-match-select-width": true,
                disabled: _ctx.categoriesSelected.firstCategorieId == null,
                onSelect: _ctx.onSecondCategorieSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: null }, {
                    default: _withCtx(() => [
                      _createTextVNode("2"),
                      _hoisted_3,
                      _createTextVNode(" catégorie")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondCategories, (categorie) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: categorie.categorieId,
                      value: categorie.categorieId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "disabled", "onSelect"]),
              (_ctx.thirdCategories.length > 0)
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    value: _ctx.categoriesSelected.thirdCategorieId,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.categoriesSelected.thirdCategorieId) = $event)),
                    style: {"width":"350px"},
                    "dropdown-match-select-width": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: null }, {
                        default: _withCtx(() => [
                          _createTextVNode("3"),
                          _hoisted_4,
                          _createTextVNode(" catégorie")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdCategories, (categorie) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: categorie.categorieId,
                          value: categorie.categorieId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}